module.exports = __webpack_public_path__ + "img/744.187ff1d3.jpg";